module.exports = __webpack_public_path__ + "assets/media/DEFAULT_PROFILE_IMAGE.f06bb8b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/DEFAULT_PROFILE_IMAGE.svg
// module id = 2012
// module chunks = 0